import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from "react-hook-form"
import { Box, Paper, Stack, Button, Collapse, Card, Grid, useTheme, MenuItem, Select, Checkbox, ListItemText } from "@mui/material"


import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';

import {
    ApiFindDropdown,
    ApiDashboardAnalyticsV2,
    ApiFindCheckList,
    ApiAnalyticsGraph

} from 'utils/api/analytics'


import ColumnChart from 'utils/components/column-charts-v1'

import GroupColumnChart from 'utils/components/chart/group-column-chart'
import BarChartNormal from 'utils/components/chart/bar-chart-new'

function Index() {

    const [profile, setProfile] = useState('')

    const user = useSelector(getUser);

    const [findYear, setFindYear] = useState([])
    const [findDepartment, setFindDepartment] = useState([])
    const [findAgeGroup, setFindAgeGroup] = useState([])


    const [findBMIAnalytics, setFindBMIAnalytics] = useState(null)
    const [findBPAnalytics, setFindBPAnalytics] = useState(null)
    const [findTcAnalytics, setFindTcAnalytics] = useState(null)
    const [findTrigAnalytics, setFindTrigAnalytics] = useState(null)
    const [findLdlAnalytics, setFindLdlAnalytics] = useState(null)
    const [findHdlAnalytics, setFindHdlAnalytics] = useState(null)
    const [findKidneyAnalytics, setFindKidneyAnalytics] = useState(null)
    const [findAsAnalytics, setFindAsAnalytics] = useState(null)
    const [findXRayAnalytics, setFindXRayAnalytics] = useState(null)
    const [findFBSAnalytics, setFindFBSAnalytics] = useState(null)
    const [findNCDsAnalytics, setFindNCDsAnalytics] = useState(null)





    const [year, setYear] = useState('all')
    const [department, setDepartment] = useState('all')
    const [ageGroup, setAgeGroup] = useState('all')


    const methods = useForm({
        defaultValues: {

        },
    });


    const [selectedYear, setSelectedYear] = useState([]);
    const handleSelectChange = (event) => {
        const value = event.target.value; // รับค่าที่เลือก

        if (value.includes('all')) {
            // กรณีเลือก 'all'
            if (selectedYear.length === findYear.length) {
                // ถ้าเลือกทั้งหมดแล้ว → ยกเลิกการเลือกทั้งหมด
                setSelectedYear([]);
            } else {
                // ถ้าไม่ได้เลือกทั้งหมด → เลือกค่าทั้งหมด
                const allValues = findYear.map(element => element.i_code);
                setSelectedYear(allValues);
            }
        } else {
            // กรณีเลือกค่าบางส่วน → อัปเดตค่าที่เลือก
            setSelectedYear(value);
        }
    };


    const [findChecklist, setFindChecklist] = useState([])
    const [configHead, setConfigHead] = useState([
        { name: "ชื่อ นามสกุล", minWidth: "80px", align: 'left' },
        { name: "สังกัด", minWidth: "80px", align: 'left' }

    ])
    const [configBody, setConfigBody] = useState([
        { name: 'full_name', align: 'left' },
        { name: 'department_name', align: 'left' }

    ])




    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {

        ApiFindDropdown('year').then(res => {
            if (res.status) {
                let payload = [{
                    "i_code": "all",
                    "i_name": "ทั้งหมด",
                    "i_name2": "",
                    "year_int": 9999
                }]
                res.data.forEach(element => {
                    payload.push(element)
                });
                setFindYear(payload)
                setSelectedYear(['all'])
            } else {
                setFindYear([])
            }
        })

        ApiFindDropdown('department').then(res => {
            if (res.status) {
                setFindDepartment(res.data)
            } else {
                setFindDepartment([])
            }
        })

        ApiFindDropdown('age_group').then(res => {
            if (res.status) {
                setFindAgeGroup(res.data)
            } else {
                setFindAgeGroup([])
            }
        })


        // ApiFindCheckList().then(res => {
        //     if (res && res.length > 0) {
        //         res.forEach(element => {
        //             configHead.push({ name: element.field_name, minWidth: "60px", align: 'center' })
        //             configBody.push({ name: element.field, align: 'center' })
        //         });
        //         setConfigHead(configHead)
        //         setConfigBody(configBody)
        //         setFindChecklist(res)
        //     } else {
        //         setFindChecklist([])
        //     }
        // })
    }



    useEffect(() => {

        fetchDataAnalytics()

    }, [selectedYear, year, department, ageGroup])

    const handleChange = (type, e) => {
        if (type === 'year') {
            setYear(e.target.value)
        } else if (type === 'department') {
            setDepartment(e.target.value)
        } else if (type === 'age_group') {
            setAgeGroup(e.target.value)
        }
    }


    const fetchDataAnalytics = async () => {



        ApiAnalyticsGraph('bmi', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindBMIAnalytics(res.data)
            } else {
                setFindBMIAnalytics(null)
            }
        })

        ApiAnalyticsGraph('bp', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindBPAnalytics(res.data)
            } else {
                setFindBPAnalytics(null)
            }
        })

        ApiAnalyticsGraph('x_ray', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindXRayAnalytics(res.data)
            } else {
                setFindXRayAnalytics(null)
            }
        })

        ApiAnalyticsGraph('fbs', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindFBSAnalytics(res.data)
            } else {
                setFindFBSAnalytics(null)
            }
        })

        ApiAnalyticsGraph('tc', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindTcAnalytics(res.data)
            } else {
                setFindTcAnalytics(null)
            }
        })

        ApiAnalyticsGraph('trig', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindTrigAnalytics(res.data)
            } else {
                setFindTrigAnalytics(null)
            }
        })

        ApiAnalyticsGraph('ldl', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindLdlAnalytics(res.data)
            } else {
                setFindLdlAnalytics(null)
            }
        })

        ApiAnalyticsGraph('hdl', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindHdlAnalytics(res.data)
            } else {
                setFindHdlAnalytics(null)
            }
        })

        ApiAnalyticsGraph('ncds', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindNCDsAnalytics(res.data)
            } else {
                setFindNCDsAnalytics(null)
            }
        })

        ApiAnalyticsGraph('kidney', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindKidneyAnalytics(res.data)
            } else {
                setFindKidneyAnalytics(null)
            }
        })

        ApiAnalyticsGraph('as', { year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindAsAnalytics(res.data)
            } else {
                setFindAsAnalytics(null)
            }
        })
    }




    return (
        <Box sx={{ margin: "4px", flex: 1 }}>

            <FormProvider {...methods}>

                <Paper
                    sx={{
                        p: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        flex: 1,
                        overflow: "hidden",
                    }}
                >


                    <Grid container spacing={2}>

                        <Grid item xs={3} md={2}>
                            <Box sx={{ fontWeight: 600, pl: 4 }}>เลือกปี</Box>
                            <Box sx={{

                                pl: 4,
                                pb: 4,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // borderRadius: '4px', // Optional, for rounded corners
                                // padding: '8px', // Adjust padding as needed
                            }}>



                                <Select
                                    size="small"
                                    multiple
                                    value={selectedYear}
                                    onChange={handleSelectChange}
                                    renderValue={(selected) =>
                                        selectedYear.length
                                            ? selected.includes('all') // ถ้ามี 'all' ในรายการที่เลือก
                                                ? 'ทั้งหมด' // แสดงข้อความ "ทั้งหมด"
                                                : selected.join(", ") // แสดงค่าที่เลือกคั่นด้วย ", "
                                            : "เลือกปี" // ถ้าไม่มีการเลือกใด ๆ
                                    }
                                    sx={{
                                        backgroundColor: "#C8EBEB",
                                        border: "none",
                                        ".MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#C8EBEB",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#C8EBEB",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#C8EBEB",
                                        },
                                        width: "100%",
                                    }}
                                >
                                    <MenuItem disabled value="null">
                                        เลือกปี
                                    </MenuItem>

                                    {findYear.map((i, idx) => (
                                        <MenuItem key={idx} value={i["i_code"]}>
                                            <Checkbox checked={selectedYear.includes(i["i_code"])} />
                                            <ListItemText primary={i["i_name"]} />
                                        </MenuItem>
                                    ))}
                                </Select>



                            </Box>
                        </Grid>

                        <Grid item xs={6} md={4}>
                            <Box sx={{ fontWeight: 600, }}>เลือกหน่วย/ สังกัด</Box>

                            <Box sx={{

                                pb: 4,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // borderRadius: '4px', // Optional, for rounded corners
                                // padding: '8px', // Adjust padding as needed
                            }}>
                                <Select
                                    size="small"
                                    value={department || "null"}
                                    onChange={(e) => { handleChange('department', e) }}
                                    sx={{
                                        backgroundColor: '#C8EBEB',
                                        border: 'none',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        width: '100%', // Ensure the Select fills the Box width
                                    }}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกหน่วย/ สังกัด
                                    </MenuItem>
                                    <MenuItem value="all" >
                                        ทั้งหมด
                                    </MenuItem>
                                    {findDepartment.map((i, idx) => (
                                        <MenuItem key={idx} value={i['i_code']}>{i['i_name']}</MenuItem>
                                    ))}
                                </Select></Box>
                        </Grid>

                        <Grid item xs={3} md={2}>
                            <Box sx={{ fontWeight: 600, }}>เลือกช่วงอายุ</Box>

                            <Box sx={{

                                pb: 4,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // borderRadius: '4px', // Optional, for rounded corners
                                // padding: '8px', // Adjust padding as needed
                            }}>
                                <Select
                                    size="small"
                                    value={ageGroup || "null"}
                                    onChange={(e) => { handleChange('age_group', e) }}
                                    sx={{
                                        backgroundColor: '#C8EBEB',
                                        border: 'none',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        width: '100%', // Ensure the Select fills the Box width
                                    }}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกช่วงอายุ
                                    </MenuItem>
                                    <MenuItem value="all" >
                                        ทั้งหมด
                                    </MenuItem>
                                    {findAgeGroup.map((i, idx) => (
                                        <MenuItem key={idx} value={i['i_code']}>{i['i_name']}</MenuItem>
                                    ))}
                                </Select></Box>
                        </Grid>

                        <Grid item xs={3} md={2}>

                        </Grid>


                    </Grid>




                    <Box
                        sx={{
                            pt: 2,
                            pb: 2,
                            pr: 5,
                            pl: 5,
                            display: 'grid',
                            columnGap: 2,
                            rowGap: 1,
                            gridTemplateColumns: 'repeat(2, 1fr)', // Two equal columns
                        }}
                    >
                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบ NCDs'}
                                data={findNCDsAnalytics?.data_list ? findNCDsAnalytics?.data_list : []}
                                color={findNCDsAnalytics?.color_list ? findNCDsAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0001'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบ BMI'}
                                data={findBMIAnalytics?.data_list ? findBMIAnalytics?.data_list : []}
                                color={findBMIAnalytics?.color_list ? findBMIAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0002'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>
                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบความดันโลหิต'}
                                data={findBPAnalytics?.data_list ? findBPAnalytics?.data_list : []}
                                color={findBPAnalytics?.color_list ? findBPAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0003'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบน้ำตาลในเลือด'}
                                data={findFBSAnalytics?.data_list ? findFBSAnalytics?.data_list : []}
                                color={findFBSAnalytics?.color_list ? findFBSAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0004'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบ Total Cholesterol (TC)'}
                                data={findTcAnalytics?.data_list ? findTcAnalytics?.data_list : []}
                                color={findTcAnalytics?.color_list ? findTcAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0005'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบ Triglyceride'}
                                data={findTrigAnalytics?.data_list ? findTrigAnalytics?.data_list : []}
                                color={findTrigAnalytics?.color_list ? findTrigAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0006'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบ LDL'}
                                data={findLdlAnalytics?.data_list ? findLdlAnalytics?.data_list : []}
                                color={findLdlAnalytics?.color_list ? findLdlAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0007'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบ HDL'}
                                data={findHdlAnalytics?.data_list ? findHdlAnalytics?.data_list : []}
                                color={findHdlAnalytics?.color_list ? findHdlAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0008'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                                
                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบการตรวจตับ'}
                                data={findAsAnalytics?.data_list ? findAsAnalytics?.data_list : []}
                                color={findAsAnalytics?.color_list ? findAsAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0009'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบการตรวจไต'}
                                data={findKidneyAnalytics?.data_list ? findKidneyAnalytics?.data_list : []}
                                color={findKidneyAnalytics?.color_list ? findKidneyAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0010'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                        <Box
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pt: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'เปรียบเทียบการตรวจ X-RAY'}
                                data={findXRayAnalytics?.data_list ? findXRayAnalytics?.data_list : []}
                                color={findXRayAnalytics?.color_list ? findXRayAnalytics?.color_list : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0011'
                                filter={{ year: selectedYear.includes('all') ? 'all' : selectedYear.join(','), department_code: department === 'all' ? null : department, age: ageGroup === 'all' ? null : ageGroup }}

                            />
                        </Box>

                    </Box>





                </Paper>
            </FormProvider>
        </Box >

    )
}

export default Index
